import Vue from "vue";
import VueRouter from "vue-router";

import Auth from "./pages/Auth/index.vue";

import Simulator from "./pages/Simulator/index.vue";
import Simulations from "./pages/Simulations/index.vue";
//import TermsAndConditions from "./pages/TermsAndConditions.vue";

import { capitalizeFirstLetter } from "@/utils";

import branding from "@/branding";

const { BRAND_NAME } = branding;

import store from "@/store";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		redirect: {
			name: "Dashboard",
		},
	},
	{
		path: "/login",
		name: "Login",
		component: Auth,
		props: {
			screen: "login",
		},
		meta: {
			title: "Login",
			requiresNoAuth: true,
		},
	},
	{
		path: "/register",
		name: "Register",
		component: Auth,
		props: {
			screen: "register",
		},
		meta: {
			title: "Register",
			requiresNoAuth: true,
		},
	},

	{
		path: "/forgot-password",
		name: "ForgotPassword",
		component: Auth,
		props: {
			screen: "forgotPassword",
		},
		meta: {
			title: "Forgot Password",
			requiresNoAuth: true,
		},
	},

	{
		path: "/reset-password",
		name: "ResetPassword",
		component: Auth,
		props: {
			screen: "resetPassword",
		},

		meta: {
			title: "Reset Password",
			requiresNoAuth: true,
		},
	},

	{
		path: "/dashboard",
		name: "Dashboard",
		component: Simulator,
		props: {
			simulation: "new",
			step: "general",
		},
		meta: {
			title: "Dashboard",
			requiresAuth: true,
		},
	},

	{
		path: "/simulator",
		name: "SimulatorNew",
		redirect: {
			name: "Simulator",
			params: {
				simulation: "new",
			},
		},
	},

	{
		path: "/simulator/:simulation",
		name: "Simulator",
		component: Simulator,
		props: ({ params, query }) => {
			return {
				simulation: params.simulation,
				step: query.step ?? "general",
			};
		},
		meta: {
			title: ({ query }) => {
				const step = query.step ?? "general";
				return `${Vue.$t("Simulador")} — ${capitalizeFirstLetter(
					Vue.$t(step)
				)}`;
			},
			requiresAuth: true,
		},
	},

	{
		path: "/simulations",
		component: Simulations,

		meta: {
			title: "Your Saved Simulations",
			requiresAuth: true,
		},
	},

	// {
	// 	path: "/terms-and-conditions",
	// 	name: "TermsAndConditions",
	// 	component: TermsAndConditions,
	// 	meta: {
	// 		title: "Terms and Conditions",
	// 	},
	// },

	{
		path: "/logout",
		name: "Logout",
		props: true,
		beforeEnter(to, from, next) {
			store.dispatch("user/logout").then(() => {
				next({ name: "Login" });
			});
		},
	},

	{
		path: "/404",
		alias: "*",
		redirect: {
			name: "Home",
		},
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
	linkExactActiveClass: "is-active--exact",
	linkActiveClass: "is-active",
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: "smooth",
			};
		}

		return { x: 0, y: 0 };
	},
});

router.beforeEach((to, from, next) => {
	const userStore = store.state.user;

	userStore.authProcess.then(() => {
		if (
			to.matched.some((record) => record.meta.requiresAuth) &&
			!userStore.user
		) {
			next({
				name: "Login",
				query: {
					redirectTo: to.path,
				},
			});
		} else if (
			to.matched.some((record) => record.meta.requiresNoAuth) &&
			userStore.user
		) {
			next({
				name: "SimulatorNew",
			});
		} else {
			next();
		}
	});
});

function updatePageTitle(currentRoute) {
	const title =
		typeof currentRoute.meta.title === "function"
			? currentRoute.meta.title(currentRoute)
			: currentRoute.meta.title;
	document.title = BRAND_NAME + (title ? ` | ${title}` : "");
}

// Page Title
router.afterEach((to, from) => {
	// Use next tick to handle router history correctly
	// see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
	Vue.nextTick(() => {
		updatePageTitle(to);
	});
});

Vue.$t.onLangChange(() => {
	updatePageTitle(router.currentRoute);
});

export default router;
